import _range from 'lodash/range';

const MANUAL_STUDIO_DEFAULT_MAX_CAPACITY = 45;
const MANUAL_STUDIO_MIN_ALLOCATION_INCREASE = 5;
export const DEFAULT_CLASSPASS_SPOTS_STEP = 1;

// allocatable = unreserved & unallocated
const getAllocatableSpots = schedule => {
  const { hasIntegrationData, spots } = schedule;
  const { classpassBooked, classpassTotal, maxCapacity, totalBooked } = spots || {};
  const directReservations = !hasIntegrationData ? 0 : totalBooked - classpassBooked;
  const allocatableSpots = !hasIntegrationData
    ? MANUAL_STUDIO_MIN_ALLOCATION_INCREASE
    : maxCapacity - classpassTotal - directReservations;

  return allocatableSpots;
};

export const getClasspassSpotsAllocationMinMax = schedule => {
  const { hasIntegrationData, opportunity, spots } = schedule;
  const { classpassBooked, classpassTotal } = spots || {};
  const { recommendation = 0 } = opportunity || {};

  // we have overbooked the schedule ☹
  // only apply when classpassTotal > 0 to avoid blocking disabled classes with existing reservations
  if (classpassBooked > classpassTotal && classpassTotal > 0) {
    return {
      minClasspassSpots: classpassTotal,
      maxClasspassSpots: classpassTotal,
    };
  }

  const allocatableSpots = getAllocatableSpots(schedule);

  const minClasspassSpots = classpassBooked;

  let maxClasspassSpots;
  if (hasIntegrationData) {
    maxClasspassSpots = Math.max(classpassTotal, classpassTotal + allocatableSpots);
  } else {
    maxClasspassSpots = Math.max(
      Math.max(classpassTotal, MANUAL_STUDIO_DEFAULT_MAX_CAPACITY),
      classpassBooked,
      classpassBooked + allocatableSpots,
      classpassBooked + recommendation
    );
  }

  return { minClasspassSpots, maxClasspassSpots };
};

export const getClasspassSpotsAllocationRange = schedule => {
  const { minClasspassSpots, maxClasspassSpots } = getClasspassSpotsAllocationMinMax(schedule);

  return _range(minClasspassSpots, maxClasspassSpots + 1);
};

export const getClasspassSpotsAllocationMinMaxForStepper = schedule => {
  return getClasspassSpotsAllocationMinMax(schedule);
};
